import axios from "axios";
import {emptyObject} from "../../dev/js/core/Helpers/Helpers";

const Cart = () => {
	const LANG = document.querySelector("html").getAttribute("lang");
	let getLang = localStorage.getItem('lang'),
		lang = JSON.parse(getLang),
		keys = {37: 1, 38: 1, 39: 1, 40: 1}
	;
	
	function autoRedirectToPayment() {
		console.log('autoR');
		let link = document.querySelector('#js-auto-redirect');
		if (link) {
			console.log('autoR2');
			console.log(link.getAttribute('href'));
			window.location.href = link.getAttribute('href');
		}
	}
	
	function autocompletePostal() {
		let postalFields = document.getElementsByClassName("JS__cart-postal");
		let shippingTextEl = document.querySelector("#cart-summary__delivery-time");
		
		
		Array.from(postalFields).forEach(postalField => {
			if (postalField) {
				postalField.addEventListener('change', e => {
					let element = e.currentTarget;
					let cityField = document.querySelector(element.dataset.target) || null;
					
					if (element) {
						let response = axios('postal-code.json', {params: {'postal': element.value}});
						
						response.then(r => {
							if (r.data.status && r.data.status === 'success') {
								// load city
								if (cityField && r.data.data.postalCity && r.data.data.postalCity.poststed) {
									cityField.value = r.data.data.postalCity.poststed;
								}
								
								if (shippingTextEl && r.data.data.shippingTime.ID) {
									shippingTextEl.innerText = r.data.data.shippingTime.Nazwa;
								}
							}
						});
					}
				});
			}
		});
		
	}
	
	function preventDefault(e) {
		e = e || window.event;
		if (e.preventDefault)
			e.preventDefault();
		e.returnValue = false;
	}
	
	function preventDefaultForScrollKeys(e) {
		if (keys[e.keyCode]) {
			preventDefault(e);
			return false;
		}
	}
	
	function disableScroll() {
		if (window.addEventListener) // older FF
			window.addEventListener('DOMMouseScroll', preventDefault, false);
		window.onwheel = preventDefault; // modern standard
		window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
		window.ontouchmove = preventDefault; // mobile
		document.onkeydown = preventDefaultForScrollKeys;
	}
	
	function enableScroll() {
		if (window.removeEventListener)
			window.removeEventListener('DOMMouseScroll', preventDefault, false);
		window.onmousewheel = document.onmousewheel = null;
		window.onwheel = null;
		window.ontouchmove = null;
		document.onkeydown = null;
	}
	
	// disableScroll();
	$(document).on('click', '.add-to-cart__status--close', function (e) {
		e.preventDefault();
		// enableScroll();
		$('#overlay_loader_cart').remove();
		$('#add-to-cart-popup').fadeOut(300, function () {
			$(this).remove();
		});
	});
	
	$(document).on('click', '.js-add-to-cart-main', function (e) {
		e.preventDefault();
		let self = $(this);
		var amount = 1;
		if (self.attr("id") === "add-to-cart-main") {
			amount = $(self.data('quantity')).val();
		}
		
		let
			parameters = {},
			ilosc = amount,
			productId = self.data('id')
		;
		let link = `add-to-cart,${productId}.html`;
		
		$('#overlay_loader_cart').remove();
		
		if (ilosc === undefined) {
			ilosc = 1;
		}
		
		$('body').append('<div id="overlay_loader_cart" class="overlay"><div class="loader"><span class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i><i class="fa fa-cog fa-spin fa-stack-1x"></i></span></div></div>').delay(2000);
		
		if (self.attr("id") === "add-to-cart-main") {
			$('#product-parameters').find('select').each(function () {
				if ($(this).attr('name') !== undefined) {
					parameters[$(this).attr('name')] = $(this).val();
				}
			});
		}
		
		// parameters['rand'] = Math.random();
		
		let params = buildUrlParams(parameters);
		
		$.ajax({
			url: link + params + "&ajax=1&ilosc=" + ilosc,
			success: function (data) {
				$('#overlay_loader_cart').remove();
				$('body').append(data);
				RefreshBasket();
				// location.reload();
			},
			// timeout: 10000,
			error: function () {
				alert('Podczas próby połączenia ze sklepem wystąpił błąd! Spróbuj ponownie za chwilę.');
				$('#overlay_loader_cart').remove();
			}
		});
	});
	$('#js-check-all').change(function (e) {
		let self = $(this);
		let target = $(self.data('target'));
		let flag = self.is(':checked');
		target.each(function () {
			let item = $(this);
			item.prop('checked', flag);
		})
	})
	
	$($('#js-check-all').data('target')).change(function (e) {
		let self = $(this);
		let flag = self.is(':checked');
		if (!flag) {
			$('#js-check-all').prop('checked', false);
		}
	})
	
	$(document).on('click', '.js-delete-from-cart-main', function (e) {
		e.preventDefault();
		
		let self = $(this),
			parameters = {},
			ilosc = $('#' + self.data('rel')).val(),
			productId = self.data('pid')
		;
		
		window.dataLayer = window.dataLayer || [];
		let gtmData = {
			event: 'remove_from_cart',
			ecommerce: {
				currency: self.data('currency'),
				value: self.data('value'),
				items: [{
					item_name: self.data('name'),
					item_id: self.data('id'),
					price: self.data('price'),
					item_category: self.data('category'),
					item_variant: self.data('variant'),
					index: self.data('index'),
					quantity: self.data('quantity')
				}]
			}
		};
		// console.log(gtmData);
		window.dataLayer.push(gtmData);
		
		let link = `usun_z_koszyka,${productId}.html`;
		
		$('#overlay_loader_cart').remove();
		
		if (ilosc === undefined) {
			ilosc = 1;
		}
		
		let params = buildUrlParams(parameters);
		
		$.ajax({
			url: link + params + "&ajax=1&ilosc=" + ilosc,
			success: function (data) {
				$('#overlay_loader_cart').remove();
				$('body').append(data);
				RefreshBasket();
			},
			// timeout: 10000,
			error: function () {
				alert('Podczas próby połączenia ze sklepem wystąpił błąd! Spróbuj ponownie za chwilę.');
				$('#overlay_loader_cart').remove();
			}
		});
	});
	
	function buildUrlParams(params) {
		let queryString = "";
		if (typeof params === 'object') {
			let pairs = [];
			for (let key in params) {
				pairs.push(key + "=" + params[key]);
			}
			
			queryString += "?" + pairs.join("&");
		}
		
		return queryString;
	}
	
	function RefreshBasket() {
		let html = '';
		let orderProductID = $(document).find('.add-to-cart__product').data("orderProduct");
		if (orderProductID) {
			$.get('pobierz_produkty_ajax.html?' + $.now(), function (data) {
				if (data) {
					let array = $.parseJSON(data);
					
					if (array.products && !emptyObject(array.products)) {
						$.each(array, function (k, v) {
							if (k === 'products') {
								if (v[orderProductID]['Ilosc'] >= 1) {
									$(document).find('#small-cart-item').html("" +
										"<div class=\"small-cart__row\">" +
										"<div class=\"small-cart__image\" style=\"background-image: url(mini2,offer," + v[orderProductID]['IDZdjecia'] + ",120,106." + v[orderProductID]['EXT'] + ");\"></div>" +
										"<div class=\"small-cart__data\">" +
										"<h3 class=\"small-cart__title\"><a href=\"" + v[orderProductID]['Link'] + "\">" + v[orderProductID]['Nazwa'] + "</a></h3>" +
										"<p>" +
										lang['cart_quantity'] + " <span class=\"quantity\">" + v[orderProductID]['Ilosc'] + "</span><br>" +
										lang['cart_price'] + " <span class=\"price\">" + v[orderProductID]['Wartosc'] + " " + v[orderProductID]['Waluta'] + "</span>" +
										"</p>" +
										"</div>" +
										"<a class=\"small-cart__remove-item\" href=\"usun_z_koszyka," + v[orderProductID]['IDProduktu'] + ".html\">" +
										"<i class=\"fa fa-trash-o\"></i>" +
										"</a>" +
										"<div class=\"clearfix\"></div>" +
										"</div>" +
										"");
								}
								let product = $(document).find('#IDP-' + v[orderProductID]['IDProduktu']);
								$(product).find('.quantity').html(v[orderProductID]['Ilosc']);
								$(product).find('.price').html(v[orderProductID]['Wartosc'] + " " + v[orderProductID]['Waluta']);
							}
							
							if (k === 'currentCount') {
								$(document).find('.small-cart__badge').html(v);
							}
						});
					} else {
						window.location.href = window.links.cart.Koszyk;
					}
				} else {
					window.location.href = window.links.cart.Koszyk;
				}
			});
		} else {
			window.location.reload();
		}
	}
	
	let onQtyChange = () => {
		var quantityTimeout = null;
		
		$(document).on("click", ".js-cart-item__count__button", function (e) {
			if (quantityTimeout != null) {
				clearTimeout(quantityTimeout);
			}
			
			let self = $(this);
			let input = $(self.data('target'));
			let value = parseInt(input.val());
			
			if (self.data('direction') == 'up' && value < input.data('max')) {
				input.val(value + 1);
			} else if (self.data('direction') == 'down' && value > input.data('min')) {
				input.val(value - 1);
			}
			
			quantityTimeout = setTimeout(function () {
				$('body').append('<div id="js-page-locker" class="page-locker"></div>');
				let form = self.closest("form");
				form.submit();
			}, 400);
		});
	};
	
	let onDeliveryChange = () => {
		$(document).on("change", ".cart-shipment__JS_delivery", function (e) {
			let element = e.target;
			let ajax = axios('get_payments.html?IDK=' + element.value);
			
			ajax.then(function (response) {
				let data = response.data;
				$(document).find("#cart-payments").html(data);
				
				updateCosts(element.dataset.value, element.dataset.currency);
			});
		});
	};
	
	let onPaymentChange = () => {
		/*$(document).on("change", ".cart-shipment__JS_payment", function(e){
			let element = e.target;
			let form = element.closest("form");

			form.submit();
		});*/
	};
	
	let updateCosts = (deliveryCost, currency) => {
		let totalCost = document.getElementById('cart-summary__JS_total-cost').value;
		let deliveryCostElement = document.getElementById('cart-summary__delivery-cost');
		let totalCostElement = document.getElementById('cart-summary__total-cost');
		
		deliveryCostElement.innerText = parseFloat(deliveryCost).toFixed(2) + " " + currency;
		totalCostElement.innerText = (parseFloat(totalCost) + parseFloat(deliveryCost)).toFixed(2) + " " + currency;
	};
	
	let legacy = () => {
		let timeout;
		$('.item-amount-change.item-plus').click(function () {
			let item = $(this);
			let x = $('#' + $(this).attr('rel')).val() * 1;
			$('#' + $(this).attr('rel')).val(x + 1)
			window.clearTimeout(timeout);
			timeout = window.setTimeout(function () {
				$('#' + item.data('form')).submit();
			}, 1000);
			return false;
		});
		
		$('.item-amount-change.item-minus').click(function () {
			let item = $(this);
			let x = $('#' + $(this).attr('rel')).val() * 1;
			$('#' + $(this).attr('rel')).val(x - 1)
			window.clearTimeout(timeout);
			timeout = window.setTimeout(function () {
				$('#' + item.data('form')).submit();
			}, 1000);
			return false;
		});
		
		$('.amount_input').change(function () {
			let item = $(this);
			window.clearTimeout(timeout);
			timeout = window.setTimeout(function () {
				$('#' + item.data('form')).submit();
			}, 1000);
		});
		
		if ($('#VAT').is(':checked')) {
			$('#inputsVAT').show();
		} else {
			$('#inputsVAT').hide();
		}
		
		$('#VAT').change(function () {
			$('#inputsVAT').slideToggle(500);
		});
		
		if ($('#AnotherAddress').is(':checked')) {
			$('#inputsAnotherAddress').show();
		} else {
			$('#inputsAnotherAddress').hide();
		}
		
		$('#AnotherAddress').change(function () {
			$('#inputsAnotherAddress').slideToggle(500);
		});
		
		$('#copyAddressData').click(function () {
			// $('#DDFImie').val($('#Imie').val());
			// $('#DDFNazwisko').val($('#Nazwisko').val());
			$('#DDFAdres').val($('#Adres').val());
			$('#DDFKodPocztowy').val($('#KodPocztowy').val());
			$('#DDFMiejscowosc').val($('#Miejscowosc').val());
		});
		
		$('#copyAnotherAddress').click(function () {
			$('#DDIImie').val($('#Imie').val());
			$('#DDINazwisko').val($('#Nazwisko').val());
			$('#DDITelefon').val($('#Telefon').val());
			$('#DDIAdres').val($('#Adres').val());
			$('#DDIKodPocztowy').val($('#KodPocztowy').val());
			$('#DDIMiejscowosc').val($('#Miejscowosc').val());
			$('#DDIIDKraju').val($('#IDKraju').val());
		});
		
		$('.sky-form').submit(function () {
			$(this).find('.note').hide();
		});
		
	};
	
	const init = () => {
		legacy();
		onQtyChange();
		onDeliveryChange();
		onPaymentChange();
		autoRedirectToPayment();
		
		if (LANG === 'no') {
			autocompletePostal();
		}
	};
	
	init();
};

const cart = new Cart();
export {cart};


// WEBPACK FOOTER //
// ../components/cart/cart.js